/**
 * document-routes
 * com.ksoft
 *
 * OpenAPI spec version: 1.1
 * Contact: fposada@ksoftonline.co
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Documento } from '../model/documento';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ConsultaDeDocumentosService {

    protected basePath = 'http://localhost:8083/dr';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Listar todos los documentos
     * Retorna el resumen de todos los documentos registrados. Se puede filtrar opcionalmente por estado de procesamiento.
     * @param estado Filtrar por estado: RECIBIDO | CLASIFICADO | ENRUTADO | PROCESADO | ERROR
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listarDocumentos(estado?: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public listarDocumentos(estado?: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public listarDocumentos(estado?: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public listarDocumentos(estado?: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (estado !== undefined && estado !== null) {
            queryParameters = queryParameters.set('estado', <any>estado);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/documents`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar documentos por estado
     * Retorna todos los documentos que se encuentran en un estado determinado del flujo de procesamiento.
     * @param estado Estado del documento: RECIBIDO | CLASIFICADO | ENRUTADO | PROCESADO | ERROR
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listarPorEstado(estado: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public listarPorEstado(estado: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public listarPorEstado(estado: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public listarPorEstado(estado: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (estado === null || estado === undefined) {
            throw new Error('Required parameter estado was null or undefined when calling listarPorEstado.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/documents/estado/${encodeURIComponent(String(estado))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar documentos de una solicitud
     * Retorna todos los documentos asociados a una solicitud. Se puede filtrar opcionalmente por estado.
     * @param solicitudId ID de la solicitud
     * @param estado Filtrar por estado: RECIBIDO | CLASIFICADO | ENRUTADO | PROCESADO | ERROR
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listarPorSolicitud(solicitudId: any, estado?: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public listarPorSolicitud(solicitudId: any, estado?: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public listarPorSolicitud(solicitudId: any, estado?: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public listarPorSolicitud(solicitudId: any, estado?: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (solicitudId === null || solicitudId === undefined) {
            throw new Error('Required parameter solicitudId was null or undefined when calling listarPorSolicitud.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (estado !== undefined && estado !== null) {
            queryParameters = queryParameters.set('estado', <any>estado);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/documents/solicitud/${encodeURIComponent(String(solicitudId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtener detalle completo de un documento
     * Retorna todos los campos del documento, incluyendo el texto extraído por OCR.
     * @param documentId UUID del documento
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public obtenerDocumento(documentId: any, observe?: 'body', reportProgress?: boolean): Observable<Documento>;
    public obtenerDocumento(documentId: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Documento>>;
    public obtenerDocumento(documentId: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Documento>>;
    public obtenerDocumento(documentId: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (documentId === null || documentId === undefined) {
            throw new Error('Required parameter documentId was null or undefined when calling obtenerDocumento.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Documento>('get',`${this.basePath}/documents/${encodeURIComponent(String(documentId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
